import { InternalAxiosRequestConfig } from 'axios'
import { useTemplateString } from '@xt/client/utils/string'
import $global from '@xt/client/store/global'
import { proxyTarget } from '@xt/client/experimental/request'

export const pathUrlInterceptors = {
  success: (options: InternalAxiosRequestConfig) => {
    options.url = useTemplateString(options.url!, options.data)

    // 处理静态资源的跨域
    if ($global.dev && options.baseURL!.indexOf($global.static!) !== -1) {
      options.baseURL = proxyTarget.static
      options.headers['Content-Type'] = 'application/x-www-form-urlencoded'
      try {
        options.params = { ...options.params, _v: $global.production ? $global.version : `${Date.now()}` }
      } catch {}
    }

    return options
  },
  fail: () => {}
}
